























import {
  defineComponent,
  getCurrentInstance,
  ref,
  PropType,
} from '@vue/composition-api'
import { ApolloError, NetworkStatus } from 'apollo-client'

import CustomSelectTemplate from '@/components/organisms/h/item/hierarchy/CustomSelectTemplate.vue'
import {
  emitHierarchySelect,
  itemHierarchyType,
  emitHierarchySearch,
  emitHierarchyRangeKeys,
  emitCustomSelectSelect,
} from '@/types/entities'
import {
  UiMCategory3sDocument,
  UiMCategory3Edge,
  Where,
} from '@/types/generated/graphql'
import { MAX_COUNT } from '@/utils/constant'
import Toast, { genNotifyMessage } from '@/utils/toast'

export default defineComponent({
  components: { CustomSelectTemplate },
  props: {
    where: {
      type: Array as PropType<Where[]>,
      default: () => [],
    },
    itemHierarchyType: {
      type: String as PropType<itemHierarchyType>,
      default: '',
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  apollo: {
    uiMCategory3s: {
      query: UiMCategory3sDocument,
      variables() {
        return this.searchCond
      },
      skip: true,
      fetchPolicy: 'cache-and-network',
      error(e: ApolloError) {
        Toast.error(this, {
          message: genNotifyMessage('e.list', 'category', e),
        })
      },
    },
  },
  created() {
    this.$apollo.queries.uiMCategory3s.skip = false
    this.isSkipQuery = false
  },
  data() {
    return {
      uiMCategory3s: { edges: [] },
      // 表示を制御するためのフラグ（データを触ると想定しない挙動となるため用意した）
      isSkipQuery: true,
      totalCount: 0,
      first: MAX_COUNT,
    }
  },
  computed: {
    isLoading() {
      return this.$apollo.queries.uiMCategory3s.loading
    },
    categoryList() {
      // 一覧
      return this.uiMCategory3s.edges.map((ele: UiMCategory3Edge) => {
        return {
          value: ele.node?.category3Cd,
          text: ele.node?.categoryName,
          key: [
            ele.node?.category1Cd,
            ele.node?.category2Cd,
            ele.node?.category3Cd,
          ].join('_'),
        }
      })
    },
    searchCond(props: any) {
      return {
        where: props.where,
        orderBy: [],
        first: this.first,
      }
    },
  },
  watch: {
    where(newVal) {
      this.resetFirst()
    },
    uiMCategory3s(data) {
      this.totalCount = this.uiMCategory3s.totalCount
    },
  },
  methods: {
    changeSelected(emitParams: emitCustomSelectSelect) {
      const setectedMetaInfo = this.uiMCategory3s.edges.filter(
        (ele: UiMCategory3Edge) => {
          const key = [
            ele.node?.category1Cd,
            ele.node?.category2Cd,
            ele.node?.category3Cd,
          ].join('_')
          if (key) {
            for (const selKey of emitParams.keyList) {
              if (selKey.indexOf(key) !== -1) {
                return true
              }
            }
          }
        }
      )
      const params: emitHierarchySelect = {
        itemHierarchyType: 'Category',
        selected: emitParams.selectList,
        selectedCount: emitParams.selectedCount,
        setectedMetaInfo: setectedMetaInfo,
      }
      this.$emit('change-selected', params)
    },
    onSearch(params: emitHierarchySearch) {
      this.$emit('search', params)
    },
    onSearchWord(params: emitHierarchySearch) {
      console.log('search-word')
      this.$emit('search-word', params)
    },
    changeRangeKey(params: emitHierarchyRangeKeys) {
      this.$emit('change-rangeKey', params)
    },
    countOverOk(params: any) {
      this.first = params
    },
    resetFirst() {
      this.first = MAX_COUNT
    },
  },
})
